import * as React from 'react';

import * as style from './styles.css';

export interface IFixedBlockProps {
  top: number;
  children: React.ReactElement<any>;
}

export const FixedBlock: React.FC<IFixedBlockProps> = ({ top, children }) => {
  return (
    <div data-testid="FixedBlock" style={{ top }} className={style['layout']}>
      {children}
    </div>
  );
};
